import React from 'react';

import { Box, Divider, Grid, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormCheck,
    ReactHookFormIntlNumberInput,
} from 'common/components/form';

import { handleOnBlurField } from '../../helpers';

const PowerLimit = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'power_values';

    const powerValues = useWatch({ control, name });

    return (
        <Box>
            <Typography fontWeight={600} variant="body2">
                {t('Power limit')}
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid container>
                <Grid size="auto">
                    <ReactHookFormCheck
                        control={control}
                        disabled={disabled}
                        name={`${name}.isChecked`}
                    />
                </Grid>
                <Grid size="grow">
                    <ReactHookFormIntlNumberInput
                        append="kW"
                        control={control}
                        disabled={
                            !powerValues || !powerValues.isChecked || disabled
                        }
                        fullWidth
                        label={t('Minimum power')}
                        name={`${name}.min`}
                        onBlur={({ value }) =>
                            handleOnBlurField({
                                name: `${name}.min`,
                                setValue,
                                value,
                            })
                        }
                    />
                </Grid>
                <Grid size="grow">
                    <ReactHookFormIntlNumberInput
                        append="kW"
                        control={control}
                        disabled={
                            !powerValues || !powerValues.isChecked || disabled
                        }
                        fullWidth
                        label={t('Maximum power')}
                        name={`${name}.max`}
                        onBlur={({ value }) =>
                            handleOnBlurField({
                                name: `${name}.max`,
                                setValue,
                                value,
                            })
                        }
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

PowerLimit.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default PowerLimit;
